<template>
  <el-select v-model="code" :placeholder="placeholder" :key="modelKey" @change="changeSelectedNode()" :disabled="disabled" clearable>
    <el-option v-for="(item, index) in tree" :key="index" :label="item.Value" :value="item.Key"></el-option>
  </el-select>
</template>

<script>
import API from '../apis/base-api'
// import qs from 'qs'

export default {
  name: 'AreaCascader',
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: '请选择地区'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tree: [], // 地区树
      code: '', // 地区代码
      modelKey: 0
    }
  },
  watch: {
    value (newValue) {
      if (this.code !== newValue) {
        if (newValue === null) this.$set(this, 'code', '')
        else this.$set(this, 'code', newValue)
      }
    }
  },
  methods: {
    init () {
      this.getArea()
    },
    Refresh () {
      this.modelKey++
    },
    getArea () {
      this.axios.get(API.FOSHAN_AREA_LIST).then(response => {
        this.$set(this, 'tree', response.Data.area)
      })
    },
    changeSelectedNode () {
      this.$emit('changeArea', this.code)
    }
  },
  created () {
    this.init()
  }
}
</script>
